module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"bulk-parcels":"Bulk Parcels","logout":"Logout"}}')
  delete Component.options._Ctor
}
